import React from 'react';
import { PrimaryButton } from '../../common';
import './add-preferred-dealer.lincoln.scss';
import serverSideService from '../../../services/server-side-service/server-side-service';

interface Props {
    addPreferredDealerTitle: string;
    addPreferredDealerSubtitle: string;
    locateDealerCTALabel: string;
    locateDealerCTAUrl: string;
}

const AddPreferredDealer = (props: Props) => {
    const goToDealerLocator = () => {
        if (serverSideService.isClientSide()) {
            window.open(props.locateDealerCTAUrl, '_blank');
        }
    };
    return (
        <div className="add-preferred-dealer-wrapper">
            <div className="apd-header">{props.addPreferredDealerTitle}</div>
            <div className="apd-sub-header">
                {props.addPreferredDealerSubtitle}
            </div>
            <div className="apd-buttons">
                <PrimaryButton
                    className="locate-dealer-button"
                    color="dark"
                    chevron={true}
                    fill="fill"
                    onClick={goToDealerLocator}
                >
                    {props.locateDealerCTALabel}
                </PrimaryButton>
            </div>
        </div>
    );
};

export default AddPreferredDealer;
